export default __webpack_public_path__ + "c2c3b00346753aa35b4705e11dd65722.png";